import {command, queryAll, queryOne, querySearch} from "../utils/api";

const GET_STAFFROLES_URL = `${process.env.PUBLIC_URL}/api/v1/r/staffRoles`;

export const GET_STAFFROLES = 'GET_STAFFROLES';
export const GET_STAFFROLES_COMPLETED = 'GET_STAFFROLES_COMPLETED';
export const GET_STAFFROLES_FAILED = 'GET_STAFFROLES_FAILED';
export function getStaffRoles() {
  const queryFilter = {
    order: "name ASC"
  };
  return queryAll(GET_STAFFROLES_URL, queryFilter, GET_STAFFROLES, GET_STAFFROLES_COMPLETED, GET_STAFFROLES_FAILED);
}

export const SEARCH_STAFF_ROLES = 'SEARCH_STAFF_ROLES';
export const SEARCH_STAFF_ROLES_COMPLETED = 'SEARCH_STAFF_ROLES_COMPLETED';
export const SEARCH_STAFF_ROLES_FAILED = 'SEARCH_STAFF_ROLES_FAILED';
export const searchStaffRoles = querySearch(GET_STAFFROLES_URL, SEARCH_STAFF_ROLES, SEARCH_STAFF_ROLES_COMPLETED,
  SEARCH_STAFF_ROLES_FAILED, 'name');

export const GET_CASHIER = 'GET_CASHIER';
export const GET_CASHIER_COMPLETED = 'GET_CASHIER_COMPLETED';
export const GET_CASHIER_FAILED = 'GET_CASHIER_FAILED';
export function getStaffRole({staffRoleId}) {
  return queryOne(GET_STAFFROLES_URL, {where: {staffRoleId}}, GET_CASHIER, GET_CASHIER_COMPLETED, GET_CASHIER_FAILED);
}

const ADD_CASHIER_URL = `${process.env.PUBLIC_URL}/api/v1/staffRole/addStaffRole`;
export const ADD_CASHIER = 'ADD_CASHIER';
export const ADD_CASHIER_COMPLETED = 'ADD_CASHIER_COMPLETED';
export const ADD_CASHIER_FAILED = 'ADD_CASHIER_FAILED';
export const addStaffRole = command(ADD_CASHIER_URL, ADD_CASHIER, ADD_CASHIER_COMPLETED, ADD_CASHIER_FAILED);

const UPDATE_CASHIER_URL = `${process.env.PUBLIC_URL}/api/v1/staffRole/updateStaffRole`;
export const UPDATE_CASHIER = 'UPDATE_CASHIER';
export const UPDATE_CASHIER_COMPLETED = 'UPDATE_CASHIER_COMPLETED';
export const UPDATE_CASHIER_FAILED = 'UPDATE_CASHIER_FAILED';
export const updateStaffRole = command(UPDATE_CASHIER_URL, UPDATE_CASHIER, UPDATE_CASHIER_COMPLETED,
  UPDATE_CASHIER_FAILED);



// WEBPACK FOOTER //
// ./src/StaffRole/actions.js